import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideLead,
  GuideCallout,
  GuideCompare,
  GuideSectionLabel,
  GuideBlockList,
} from "../GuideBlocks.js";

const UnderstandingShameSection = ({ heading, accentIndex = 2, getVisual, getAccent }) => (
  <GuidePanel
    sectionId="understanding-shame"
    heading={heading}
    accentIndex={accentIndex}
    getVisual={getVisual}
    getAccent={getAccent}
  >
    <GuideLead>
      Shame is one of the most painful human emotions. It is different from guilt.
    </GuideLead>
    <GuideCompare
      leftTitle="Guilt"
      rightTitle="Shame"
      left={<p>Guilt says, "I made a mistake." Guilt focuses on behavior.</p>}
      right={<p>Shame says, "I am the mistake." Shame attacks identity.</p>}
    />
    <p className="guide-panel__p">
      When shame becomes persistent, people may begin to hide, withdraw, or believe they are unworthy
      of love, respect, or success.
    </p>
    <GuideSectionLabel>Signs of shame</GuideSectionLabel>
    <GuideBlockList
      items={[
        "Fear of being judged.",
        "Constant self-criticism.",
        'Feeling "not good enough."',
        "Avoiding vulnerability.",
        "Perfectionism.",
        "Hiding mistakes.",
      ]}
    />
    <GuideCallout variant="amber">
      The pattern loosens when you recognize that making mistakes is part of being human. Instead of asking,
      "What's wrong with me?" try asking, "What happened that led me to believe this about myself?"
    </GuideCallout>
    <GuideCallout>
      Replacing identity-level judgment with an examined interpretation is how the belief gets updated.
    </GuideCallout>
  </GuidePanel>
);

export default UnderstandingShameSection;
